/**
 * Speech
 */

import Config from '../../Config';

class Speech {

	private $viewInfo: any = jQuery( '.view-info' );

	private $viewBody: any = jQuery( '.view-body' );

	private editorTxtSelector: string = `[ data-contents-type = "text" ]`;

	private messageMaxCount: number = 120;

	private currMessagesIndex: number;

	private messagesList: any[];

	private msg: any;

	constructor() {
		if ('speechSynthesis' in window ) {

			// current index to list of messages
			this.currMessagesIndex = 0;

			// messages list
			this.messagesList = [];

			// make message array
			this.setMessagesList();

			// setting up config for Speech
			this.setSpeech();
			this.setUI();
		}
	}

	public speak() {
		this.stop();
		this.msg.text = this.messagesList[ this.currMessagesIndex ];
		window.speechSynthesis.speak( this.msg );
	}

	public stop() {
		window.speechSynthesis.cancel();
	}

	public pause() {
		window.speechSynthesis.pause();
	}

	public resume() {
		window.speechSynthesis.resume();
	}

	private setMessagesList() {
		const $node = this.$viewBody.find( this.editorTxtSelector );
		const total = $node.length;
		let txt = '';

		$node.each( ( idx: number, value: any ) => {
			const _txt = jQuery( value ).text();
			if ( txt.length + _txt.length > this.messageMaxCount ) {
				this.messagesList.push( txt );
				txt = ` ${ _txt } `;
			} else {
				txt = ` ${ txt } ${ _txt } `;
			}

			if ( total - 1 === idx ) {
				this.messagesList.push( txt );
			}
		});
	}

	private setUI() {
		// @temp markup
		const selector = 'btnSound';
		this.$viewInfo.append( `<img src="http://ui-static.korea.ncsoft.corp/uikit/nccommunity/img/tmp/icon-speaker.png"
		width="16px" id="${ selector }" style="display:none;margin:3px;vertical-align:middle;cursor:pointer;"/>` );
		this.$viewInfo.find( `#${ selector }` ).on( 'click', () => {
			this.speak();
		});
	}

	private setSpeech() {
		this.msg = new SpeechSynthesisUtterance();
		// let voicesArr = speechSynthesis.getVoices();
		// this.msg.voice = voicesArr[ 10 ];
		this.msg.voiceURI = 'native';

		// 0 ~ 1
		this.msg.volume = 1;

		// 0.1 ~ 10
		this.msg.rate = 0.7;

		// 0 ~ 2
		this.msg.pitch = 1;
		this.msg.lang = 'ko-KR';
		this.msg.onend = ( evt: any ) => {
			this.currMessagesIndex++;

			if ( this.currMessagesIndex >= this.messagesList.length ) {
				this.stop();
				this.currMessagesIndex = 0;
				return;
			}

			this.speak();
		};
	}
}

export default Speech;
